import React from "react";
import {
  ClipboardList,
  FileText,
  MessageSquare,
  Send,
  Trash2,
} from "lucide-react";

const STEPS = [
  {
    icon: ClipboardList,
    title: "Get the job details",
    body: "Send your quote link. The customer fills out the job and adds photos.",
  },
  {
    icon: FileText,
    title: "Quote from the lead",
    body: "Open the job, check the details, then build and send the quote.",
  },
  {
    icon: MessageSquare,
    title: "Keep the chat in one spot",
    body: "Messages, photos, notes, quote, and invoice stay on the same job.",
  },
  {
    icon: Send,
    title: "Move it across the board",
    body: "Drag the job as it moves from new lead to booked work.",
  },
];

export default function HowItWorksPanel({
  showSample = false,
  sampleDismissed = false,
  onDismissSample,
}) {
  return (
    <div className="rq-how">
      <div className="rq-how__grid">
        {STEPS.map(({ icon: Icon, title, body }) => (
          <div className="rq-how__step" key={title}>
            <span className="rq-how__icon" aria-hidden="true">
              <Icon size={18} />
            </span>
            <div>
              <h3>{title}</h3>
              <p>{body}</p>
            </div>
          </div>
        ))}
      </div>

      {showSample && !sampleDismissed && (
        <div className="rq-sample-lead">
          <div className="rq-sample-lead__body">
            <span className="rq-sample-lead__badge">Sample job</span>
            <h3>Bathroom tap leak</h3>
            <p>
              This is only a preview. Real customer jobs will land on your board
              with the same detail layout.
            </p>
          </div>
          <button
            type="button"
            className="rq-icon-button"
            onClick={onDismissSample}
            aria-label="Remove sample job"
            title="Remove sample job"
          >
            <Trash2 size={16} />
          </button>
        </div>
      )}
    </div>
  );
}
